import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";
import OnboardingShell from "@/components/jk/OnboardingShell";
import { PrimaryButton } from "@/components/jk/ui";
import AvailabilityManager from "@/components/jk/AvailabilityManager";
import { useAuth } from "@/context/AuthContext";
import { useMenu } from "@/context/MenuContext";

const OnboardingAvailability = () => {
  const navigate = useNavigate();
  const { onboardingComplete } = useAuth();
  const { open: openMenu } = useMenu();
  const editMode = !!onboardingComplete;
  const backToMenu = () => { openMenu(); navigate(-1); };
  const [ready, setReady] = useState(false);

  const onDone = () => {
    if (editMode) { toast.success("Availability updated"); backToMenu(); }
    else navigate("/onboarding/payout");
  };

  return (
    <OnboardingShell
      step={editMode ? null : 3}
      title={editMode ? "Edit Availability" : "Your Availability"}
      subtitle="Set your weekly default hours, then tap any date to customise or block it."
      onBack={() => editMode ? backToMenu() : navigate("/onboarding/services")}
      testid="onboarding-availability-screen"
      footer={
        <PrimaryButton
          testid="availability-continue"
          onClick={onDone}
          disabled={!ready}
          icon={editMode ? <Check size={18} strokeWidth={2} /> : <ArrowRight size={18} strokeWidth={2} />}
        >
          {editMode ? "Done" : "Continue"}
        </PrimaryButton>
      }
    >
      <AvailabilityManager onReady={setReady} />
    </OnboardingShell>
  );
};

export default OnboardingAvailability;
